import { EnumsInterface } from "@/interfaces/EnumsInterface";

const HighSuicidalRisk:EnumsInterface[] = [
    {id: 0, value: 0, label: "NONE"},
    {id: 1, value: 1, label: "Mild"},
    {id: 2, value: 2, label: "Moderate"},
    {id: 3, value: 3, label: "Severe"},
]

export default HighSuicidalRisk